export default __webpack_public_path__ + "media/images/images/flags/de-d1fda7088343c04761a713e2faa84fec.png";